<template>
  <div class="prompt--private">
    <div class="permission__callout">
      <div class="callout__content">
        <img src="/img/Icon_Info.d5c5bb99.svg" alt="" class="permission__icon icon icon-info">
        {{ calloutCopy }}
      </div>
      <div role="button" class="v-btn primary v-size--small" @click="onUpgradeClick()" @key.enter="onUpgradeClick()">
        {{ ctaCopy }}
      </div>
    </div>
    <div class="permission__copy">
      Learn more about managing sharing link permissions at our <a class="a ink" href="https://www.jig.space/help-center/sharing-links" target="_blank">help center</a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'PasswordShareWarning',
  props: {
    eventName: {
      required: true,
      type: String,
      default: '',
    },
    callout: {
      required: true,
      type: String,
      default: '',
    },
    cta: {
      type: String,
      default: 'Upgrade',
    },
  },
  data() {
    return {
      trackingEvent: this.eventName,
      calloutCopy: this.callout,
      ctaCopy: this.cta
    }
  },
  computed: {
    ...mapState('app', ['myTenant']),
  },
  watch: {
    eventName(val) {
      this.trackingEvent = val;
    },
    callout(val) {
      this.calloutCopy = val;
    },
    cta(val) {
      this.ctaCopy = val;
    },
  },
  methods: {
    // Bind @click.native to <router-link> tag will not work, hence changing to manual router change.
    onUpgradeClick() {
      this.$auth.segmentEventTracking(this.trackingEvent, {
        tenantName: this.myTenant.Name,
        tenantId: this.myTenant.ID,
      });

      this.$router.push({ path: '/subscription' });
    },
  },
}
</script>
